<template>
  <div class="row">
    <entry-fields :tab="tab" :transition="transition" class="col-xs-12" />
    <div class="col-xs-12 col-md-6">
      <div class="contributors-container">
        <div class="contributors">
          <contributor-configurator
            v-if="configurationMode && contributors.length === 0"
            :tab="tab"
          />
          <template v-else>
            <contributor
              v-for="(contributor, index) in contributors"
              :key="'contributor-' + contributor.id"
              :contributor="contributor"
              :tab="tab"
              :can-delete="canDelete"
              :counter="index + 1"
              :locked="configurationMode"
            >
              <draggable-fields
                v-if="configurationMode"
                :fields="contributorFields(tab.id)"
                :visible-fields="visibleContributorFields(tab.id, contributor)"
                :resource-name="resourceName"
                :resource="contributor"
                :group="groupName(contributor)"
                :tab="tab"
                :lock-tabs="true"
              />
              <fields
                v-else
                :fields="visibleContributorFields(tab.id, contributor)"
                :resource-name="resourceName"
                :resource="contributor"
                :tab="tab"
                :transition="transition"
              />
            </contributor>
          </template>
        </div>
        <button
          v-if="canUpload"
          type="button"
          class="btn btn-secondary"
          :disabled="maxLimitReached || configurationMode"
          @click.prevent="addContributor(tab.id)"
        >
          {{ lang.get('entries.form.add-contributor') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Contributor from '../Contributor';
import Fields from '../Fields/Fields';
import EntryFields from '../Fields/EntryFields';
import ContributorConfigurator from '../Configuration/ContributorConfigurator';
import DraggableFields from '../Configuration/DraggableFields';

export default {
  inject: ['lang'],
  components: {
    DraggableFields,
    Contributor,
    ContributorConfigurator,
    Fields,
    EntryFields
  },
  props: {
    tab: {
      type: Object,
      required: true
    },
    transition: {
      type: String,
      default: 'push'
    }
  },
  computed: {
    resourceName() {
      return 'Contributors';
    },
    ...mapState('entryForm', ['locks']),
    ...mapState('entryFormConfiguration', ['configurationMode']),
    ...mapGetters('entryForm', [
      'visibleContributorFields',
      'contributorFields'
    ]),
    canDelete() {
      return !this.locks.readOnly;
    },
    canUpload() {
      return !this.locks.readOnly;
    },
    contributors() {
      return this.$store.getters['entryForm/contributors'](this.tab.id);
    },
    maxLimitReached() {
      return (
        this.tab.maxContributors &&
        this.contributors.length >= this.tab.maxContributors
      );
    }
  },
  methods: {
    groupName(contributor) {
      return 'contributor-' + contributor.id;
    },
    ...mapActions('entryForm', ['addContributor'])
  }
};
</script>
